export const Functions = {
  create: false,
  delete: true,
  detail: true,
  search: true,
};

export const PageName = '用户资产';
